import { Controller } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { InputFormProps } from '../FormElements.types';
import { InputWrapper } from './InputWrapper';
import { resetUpdateAutoCompleteLocationInfo } from '../../../../features/contactInfoSlice';
import { DELEGATEKEYADDRESS, PATIENT_KEY_ADDRESS, USER_TYPE } from '../../../ContactInfo/constants';

const FormInput = ({
  name,
  toolTip,
  placeholder,
  label,
  control,
  rules,
  errors,
  countryFlag,
  countryCode,
  maxLength,
  showIsMobileOption,
  isMobileLabel,
  enableAutoComplete,
  setValue,
  trigger,
  prePopulateFromScreener,
  prePopulateFromMegaScreener,
  isReadOnly,
  isMegaScreenerReadOnly,
  setError,
  addressZipcodeValidationErrorMessage,
  mobileNumberValidationMessageOnSMSConsent,
}: InputFormProps): JSX.Element => {
  const dispatch = useDispatch();

  const getUserType = (key: string) => {
    if (PATIENT_KEY_ADDRESS.indexOf(key) > -1) {
      return USER_TYPE.PATIENT;
    } else if (DELEGATEKEYADDRESS.indexOf(key) > -1) {
      return USER_TYPE.DELEGATE;
    }
    return USER_TYPE.SKIPPED;
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue=""
      render={({ field: { onChange, value, onBlur } }) => (
        <InputWrapper
          onChangeHandler={(event) => {
            const userType = getUserType(name);
            dispatch(resetUpdateAutoCompleteLocationInfo(userType));
            onChange(event);
          }}
          value={value}
          label={label}
          name={name}
          setValue={setValue}
          trigger={trigger}
          onBlur={onBlur}
          setError={setError}
          toolTip={toolTip}
          placeholder={placeholder}
          errors={errors}
          countryFlag={countryFlag}
          countryCode={countryCode}
          maxLength={maxLength}
          isMobileLabel={isMobileLabel}
          showIsMobileOption={showIsMobileOption}
          enableAutoComplete={enableAutoComplete}
          control={control}
          prePopulateFromScreener={prePopulateFromScreener}
          prePopulateFromMegaScreener={prePopulateFromMegaScreener}
          isReadOnly={isReadOnly}
          isMegaScreenerReadOnly={isMegaScreenerReadOnly}
          addressZipcodeValidationErrorMessage={addressZipcodeValidationErrorMessage}
          mobileNumberValidationMessageOnSMSConsent={mobileNumberValidationMessageOnSMSConsent}
        />
      )}
    />
  );
};

export { FormInput };
